import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HistoryBook } from '../signals/+models/history-book.model';
import { DataHistory } from '../types/data-history';

@Injectable({
  providedIn: 'root',
})
export class HistoryBookService {
  private readonly webBaseUrl =
    'https://tools.brandinstitute.com/wsGeneral/wsNWVote.asmx/';

  private readonly apiCall = 'SaveHistoryBook';

  constructor(private http: HttpClient) {}

  dataHistoryBook: DataHistory = {
    token: '38230499-A056-4498-80CF-D63D948AA57F',
    project: '',
    username: '',
    userToken: '',
    historyBook: null,
  };

  sendHistoryBook(historyBook: HistoryBook) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    this.dataHistoryBook.project = localStorage.getItem('project');
    this.dataHistoryBook.username = localStorage.getItem('username');
    this.dataHistoryBook.userToken = localStorage.getItem('userTokenId');
    this.dataHistoryBook.historyBook = historyBook;
  }
}
